import clsx from "clsx";
import styles from "./Navbar.module.css";
import { Dispatch, SetStateAction, useState } from "react";
import { images } from "../../assets/images";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { Backdrop, Divider } from "@mui/material";
import AppInit from "../AppInit/AppInit";
import CountrySelector from "../CountrySelector/CountrySelector";

interface Props {
  setIsOpen: Dispatch<SetStateAction<boolean>>;
}

const JobseekerNav = ({ setIsOpen }: Props) => {
  const navigate = useNavigate();

  const handleEmployer = () => {
    navigate("/");
  };

  const [openMenu, setOpenMenu] = useState(false);

  const handleRedirect = () => {
    const userAgent = navigator.userAgent.toLowerCase();

    if (userAgent.includes("android")) {
      // Redirect to the Google Play Store for Android users
      window.location.href =
        "https://play.google.com/store/apps/details?id=com.falektayyeb.ft&hl=en";
    } else if (userAgent.includes("iphone") || userAgent.includes("ipod")) {
      // Redirect to the Apple App Store for iOS users
      window.location.href =
        "https://apps.apple.com/ae/app/falek-tayyeb/id6471679752";
    } else {
      // Optionally, handle users on other platforms (e.g., desktop)
      alert("Your platform is not supported for app redirection.");
    }
  };

  return (
    <>
      <Backdrop open={openMenu}></Backdrop>
      <AppInit />
      <div className={styles.container}>
        <div className={styles.navbarContent}>
          <div className={styles.logoWrapper}>
            <Link to={"/"}>
              <img
                src={images.tascBrandLogo}
                className={styles.brandLogo}
              />
            </Link>
            <div className={styles.pageHolder}>For Jobseekers</div>
          </div>
          <div className={styles.rightElems}>
            <p
              onClick={handleEmployer}
              className={clsx(styles.blue, styles.bold, styles.pointer)}
            >
              Employer?
            </p>
            <div onClick={() => setIsOpen(true)} className={styles.gradientBtn}>
              Download Jobseeker App
              <img src={images.btnArrow} />
            </div>
            <CountrySelector />
          </div>
          <div
            onClick={() => setOpenMenu(!openMenu)}
            className={styles.hamburger}
          >
            <img src={images.menuNew} />
          </div>
        </div>
        {openMenu && (
          <div className={styles.mobileMenu}>
            <div className={styles.menuContent}>
              <div className={styles.menuHeader}>
                <h2>Menu</h2>
                <img
                  src={images.closeMenu}
                  className={styles.pointer}
                  onClick={() => setOpenMenu(false)}
                />
              </div>
              <Divider />
              <div
                onClick={handleRedirect}
                className={clsx(styles.gradientBtn, styles.textCenter)}
              >
                Download Jobseeker App
                <img src={images.btnArrow} />
              </div>

              <p
                onClick={handleEmployer}
                className={clsx(
                  styles.blue,
                  styles.bold,
                  styles.pointer,
                  styles.textCenter
                )}
              >
                Employer?
              </p>
              <Divider />
              <div className={styles.mobileSelectorRow}>
                <div className={styles.selectorLabel}>
                  <span className={styles.selectorIcon}>🌐</span>
                  <span>Country</span>
                </div>
                <div className={styles.mobileCountrySelector}>
                  <CountrySelector mobile={true} />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default JobseekerNav;
